import type { LinkLikeComponentProps } from "@shopify/polaris/build/ts/src/utilities/link";
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const AdapterLink = forwardRef<HTMLAnchorElement, LinkLikeComponentProps>(
  (props, ref) => {
    return <Link to={props.url} ref={ref} {...props} />;
  }
);

AdapterLink.displayName = "AdapterLink";

export default AdapterLink;
